const prod = {
  
  ENVIRONMENT: 'production',

  API_DOMAIN: 'https://api.pearson.com/gps/',

  ALS_DOMAIN: 'https://www.pearsonactivelearn.com/',

  API_KEY: 'v3BJEJFGC01g5lqDEiN03KuEvaiM5qKc'

};

export default prod;